import './App.css';
import { useReactMediaRecorder } from "react-media-recorder";
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import MicIcon from '@material-ui/icons/Mic';
import { IconButton } from '@material-ui/core';
import StopIcon from '@material-ui/icons/Stop';
import GetAppIcon from '@material-ui/icons/GetApp';
import Darkmode from 'darkmode-js';


function App() {
  const {
    status,
    startRecording,
    stopRecording,
    mediaBlobUrl,
  } = useReactMediaRecorder({ video: false });
  const options = {
    top:'64px',
    bottom: 'unset', // default: '32px'
    right: '32px', // default: '32px'
    left: 'unset', // default: 'unset'
    time: '0.5s', // default: '0.3s'
    mixColor: '#fff', // default: '#fff'
    backgroundColor: '#fff',  // default: '#fff'
    buttonColorDark: '#000',  // default: '#000'
    buttonColorLight: '#fff', // default: '#fff'
    saveInCookies: false, // default: true,
    label: '🌙', // default: ''
    autoMatchOsTheme: true // default: true
  }
  
  const darkmode = new Darkmode(options);
  darkmode.showWidget();
  function downloadURI(uri, name) 
  {
      var link = document.createElement("a");
      // If you don't know the name or want to use
      // the webserver default set name = ''
      link.setAttribute('download', name);
      link.href = uri;
      document.body.appendChild(link);
      link.click();
      link.remove();
  }
  return (
    <div className="App">
      <div>
        {(status === "idle")?<p className="status">Tap to record</p>:null}
        {(status === "recording")?<p className="status">Recording...</p>:null}
        {(status === "stopped")?<p className="status">Playing...</p>:null}
        <div className="controls">
          <IconButton onClick={startRecording} ><MicIcon style={{fontSize:"100px"}} /></IconButton>
          <IconButton onClick={stopRecording} ><StopIcon style={{fontSize:"100px"}} /></IconButton>
          <IconButton onClick={()=>{
            downloadURI(mediaBlobUrl,'recording');
          }} ><GetAppIcon style={{fontSize:"100px"}} /></IconButton>
        </div>
        <div className="player">
        <AudioPlayer
          autoPlay
          src={mediaBlobUrl}
          onPlay={e => console.log("onPlay")}
        />

        </div>
      </div>
    </div>
  );
}

export default App;
